export default "__VITE_ASSET__3ad0387c__"